import { ROUTES } from './routes';

export function getRoute(key: string): string | null {
  const data = ROUTES.find(route => route.key === key);

  if (data) { return data.route; }

  return null;
}

export function getRouteKeyMatchByUrl(url: string): string {
  return ROUTES.find(r => url.includes(r.route))?.key;
}
